import { Markdown } from '@/components/Markdown'
import type { Role, Task } from '@/lib/types'

export function BuilderSubmission({ task, role }: { task: Task; role: Role }) {
  const submission = task.authoring_submission
  if (role !== 'engineer' || !submission) return null
  return (
    <section className="box">
      <h3>Builder’s submission</h3>
      <Markdown source={submission.summary ?? 'The builder did not include a summary.'} />
      <a href={submission.pull_request.url} target="_blank" rel="noreferrer">
        View package pull request
      </a>
    </section>
  )
}
